import styled from 'styled-components';

import { ClosingIndicator } from '@xing-com/closing-indicator';
import { mediaTiny } from '@xing-com/layout-tokens';
import { PopOver as DefaultPopOver } from '@xing-com/pop-over';
import { spaceL, spaceXL, spaceXXL, space3XL } from '@xing-com/tokens';

const PopOver = styled(DefaultPopOver)`
  box-sizing: border-box;
  inline-size: min(calc(100vw - ${spaceXXL}), 424px);
  inset-block-start: 50%;
  inset-inline-end: ${spaceL};
  max-block-size: calc(100dvh - ${spaceXXL});
  overflow-y: auto;
  padding: ${space3XL} ${spaceXXL} ${spaceXXL};
  position: fixed;
  transform: translateY(-50%);

  @media ${mediaTiny} {
    inline-size: calc(100vw - ${spaceXL});
    inset-block-end: ${spaceL};
    inset-block-start: auto;
    inset-inline-end: ${spaceL};
    transform: none;
  }
`;

const CloseButton = styled(ClosingIndicator)`
  inset-block-start: ${spaceL};
  inset-inline-end: ${spaceL};
  position: absolute;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  text-align: center;
`;

export const Styled = {
  CloseButton,
  Content,
  PopOver,
};
